import {applyMiddleware, createStore} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import rootReducer from '../reducer';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../saga';

const configureStore = (preloadedState) => {
    const sagaMiddleware = createSagaMiddleware();
    const middlewares = [sagaMiddleware];

    let store;

    store = createStore(
        rootReducer,
        preloadedState,
        composeWithDevTools(
            applyMiddleware(...middlewares),
        ),
    );

    sagaMiddleware.run(rootSaga);

    // For hot mudule replacement feature (aka: automatic reload if code changed)
    if (process.env.NODE_ENV !== 'production') {
        if (module.hot) {
            module.hot.accept('../reducer', () => {
                store.replaceReducer(rootReducer);
            });
        }
    }

    return store;
};

const preloadedState = {};
const store = configureStore(preloadedState);

export default store;
